export const authRedirectUri = `${window.location.origin}/auth/authorize`;
